import { Body } from 'syf-component-library/ui/typography';
import styled from 'styled-components';
const DebtCancellationTextContainer = styled(Body) `
  font-size: 14px;
`;
export default DebtCancellationTextContainer;
